module.exports = __webpack_public_path__ + "f4962ab95e7914e8148510eebdb76d46.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sounds/donkerblauw.mp3
// module id = 28
// module chunks = 0